<svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="15.5" cy="16" r="15.5" fill-opacity="50%" opacity="50%"/>
<circle cx="15.5" cy="16" r="7.5" />
</svg>
